"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SensitiveDataGovernanceDocument(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 48 48",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.195 7.427A7.427 7.427 0 0111.622 0H38.068l2.895 2.998 2.842 2.988v19.389a7.427 7.427 0 01-7.427 7.427H11.622a7.427 7.427 0 01-7.427-7.427V7.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    fillRule: "evenodd",
    d: "M11.622 32.06h24.756a6.684 6.684 0 006.684-6.685V6.283L40.43 3.514l-.004-.004L37.753.743h-26.13a6.684 6.684 0 00-6.685 6.684v17.948a6.684 6.684 0 006.684 6.684zM38.068 0H11.622a7.427 7.427 0 00-7.427 7.427v17.948a7.427 7.427 0 007.427 7.427h24.756a7.427 7.427 0 007.427-7.427V5.985l-2.842-2.987L38.068 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9ECEF",
    d: "M5.148 11.153a7.427 7.427 0 017.427-7.427h18.567a7.427 7.427 0 017.427 7.427V24.77a7.427 7.427 0 01-7.427 7.427H12.575a7.427 7.427 0 01-7.427-7.427V11.153z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    fillRule: "evenodd",
    d: "M38.366 5.818v-5.2h-.742V6.56h5.941v-.742h-5.199z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FA",
    d: "M25.238 44.281a12.886 12.886 0 01-13.61-11.184c-.718-5.16 1.83-10.303 6.372-12.842 7.35-4.108 16.18-.374 18.64 7.203a12.822 12.822 0 01-.852 9.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    d: "M35.435 37.724a.53.53 0 00.735-.207 13.384 13.384 0 10-10.797 7.168.53.53 0 00.477-.597.566.566 0 00-.61-.488 12.291 12.291 0 119.982-6.627.566.566 0 00.213.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.82 40.005a.546.546 0 01.771.017l4.131 4.309-4.353 3.546a.546.546 0 01-.69-.846l3.437-2.8-3.313-3.454a.546.546 0 01.017-.772z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    fillRule: "evenodd",
    d: "M21.82 40.005a.546.546 0 01.771.017l4.131 4.309-4.353 3.546a.546.546 0 01-.69-.846l3.437-2.8-3.313-3.454a.546.546 0 01.017-.772z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M21.992 32.06L20 35.885c-.557 0-1.025-.468-1.025-1.054V26.4c0-.585.468-1.054 1.024-1.054h5.125l2.05 2.108-4.157 3.552c0 .586-.468 1.054-1.025 1.054zM26.802 37.345l-1.504-.996c-.942-.624-1.503-1.64-1.503-2.722v-1.545a3.516 3.516 0 002.618-.816l.389-.334.206.195a3.627 3.627 0 002.8.955v1.545c0 1.082-.561 2.098-1.503 2.722l-1.503.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.324 33.03a.28.28 0 01.02.396l-1.93 2.136-1.086-1.128a.28.28 0 01.404-.389l.669.694 1.526-1.69a.28.28 0 01.397-.02z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    fillRule: "evenodd",
    d: "M27.173 30.696a4.036 4.036 0 01-.128-.117l-.244-.23-.46.395a4.156 4.156 0 01-3.093.963v1.826c0 .86.299 1.682.831 2.353H20c-.556 0-1.024-.468-1.024-1.054V26.4c0-.585.468-1.054 1.024-1.054h5.125v2.108h2.05v3.243z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.917 27.98h-2.343c-.176 0-.293-.117-.293-.292 0-.176.117-.293.293-.293h2.343c.175 0 .292.117.292.293 0 .175-.117.292-.292.292zM23.502 29.737h-2.928c-.176 0-.293-.117-.293-.293 0-.175.117-.292.293-.292h2.928c.176 0 .293.117.293.292 0 .176-.117.293-.293.293z"
  }));
}

SensitiveDataGovernanceDocument.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SensitiveDataGovernanceDocument.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SensitiveDataGovernanceDocument;
exports["default"] = _default;